const buildServices = (items) =>
	items.map((item, index) => ({
		_id: `svc-${index + 1}`,
		service_name: item.name,
		quantity: item.qty || 1,
		charges: item.charges,
		amount: item.amount,
	}));

export const MOCK_PAID_INVOICES = [
	{
		_id: "inv-paid-001",
		invoice_no: "PLUS-260623-00001",
		invoice_type: "consultation",
		type: "consultation",
		file_no: "PLUS22",
		patient: { full_name: "Owais Hasan RAZA", health_id: "PLUS22", mobile: "2354242342", email: "" },
		patient_id: "pat-022",
		invoice_date: "2026-06-23T13:25:00",
		createdAt: "2026-06-23T13:25:00",
		payment_status: "paid",
		status: "paid",
		currency: "INR",
		invoice_amount: 800,
		paid_amount: 800,
		pending_amount: 0,
		due_amount: 0,
		invoice: "",
		doctor: { full_name: "Shane WATSON" },
		services: buildServices([
			{ name: "Face To Face Consultation", qty: 1, charges: 200, amount: 200 },
			{ name: "IV Administration Charges", qty: 1, charges: 300, amount: 300 },
			{ name: "Health Education Services", qty: 1, charges: 300, amount: 300 },
		]),
		payment_history: [
			{ payment_date: "2026-06-23T13:25:00", paid_amount: 500, payment_mode: "cash" },
			{ payment_date: "2026-06-23T14:00:00", paid_amount: 200, payment_mode: "cash" },
			{ payment_date: "2026-06-23T15:00:00", paid_amount: 100, payment_mode: "cash" },
		],
		financial_summary: {
			sub_total: 800,
			discount: 0,
			billable_amount: 800,
			net_total: 800,
			total_paid: 800,
			due: 0,
		},
	},
	{
		_id: "inv-paid-002",
		invoice_no: "PLUS-260623-00002",
		invoice_type: "consultation",
		type: "consultation",
		file_no: "PLUS22",
		patient: { full_name: "Owais Hasan RAZA", health_id: "PLUS22" },
		patient_id: "pat-022",
		invoice_date: "2026-06-23T12:00:00",
		payment_status: "paid",
		currency: "INR",
		invoice_amount: 200,
		paid_amount: 200,
		pending_amount: 0,
		due_amount: 0,
		doctor: { full_name: "Shane WATSON" },
		services: buildServices([{ name: "Face To Face Consultation", qty: 1, charges: 200, amount: 200 }]),
		payment_history: [{ payment_date: "2026-06-23T12:00:00", paid_amount: 200, payment_mode: "cash" }],
		financial_summary: { sub_total: 200, discount: 0, billable_amount: 200, net_total: 200, total_paid: 200, due: 0 },
	},
	{
		_id: "inv-paid-003",
		invoice_no: "PLUS-260623-00003",
		invoice_type: "treatment_package",
		type: "other_services",
		file_no: "PLUS22",
		patient: { full_name: "Owais Hasan RAZA", health_id: "PLUS22" },
		patient_id: "pat-022",
		invoice_date: "2026-06-23T11:00:00",
		payment_status: "paid",
		currency: "INR",
		invoice_amount: 200,
		paid_amount: 200,
		pending_amount: 0,
		due_amount: 0,
		doctor: { full_name: "Shane WATSON" },
		services: buildServices([{ name: "Treatment Package", qty: 1, charges: 200, amount: 200 }]),
		payment_history: [{ payment_date: "2026-06-23T11:00:00", paid_amount: 200, payment_mode: "card" }],
		financial_summary: { sub_total: 200, discount: 0, billable_amount: 200, net_total: 200, total_paid: 200, due: 0 },
	},
];

export const MOCK_PARTIAL_INVOICES = [
	{
		_id: "inv-partial-001",
		invoice_no: "PLUS-260623-00004",
		invoice_type: "consultation",
		type: "consultation",
		file_no: "PLUS69",
		patient: { full_name: "Sarah BROWN", health_id: "PLUS69", mobile: "", email: "" },
		patient_id: "pat-069",
		invoice_date: "2026-06-23T18:50:00",
		createdAt: "2026-06-23T18:50:00",
		payment_status: "unpaid",
		status: "unpaid",
		currency: "INR",
		invoice_amount: 100,
		paid_amount: 0,
		pending_amount: 100,
		due_amount: 100,
		doctor: { full_name: "Shane WATSON" },
		services: buildServices([{ name: "Telephone Consultation", qty: 1, charges: 100, amount: 100 }]),
		payment_history: [],
		financial_summary: { sub_total: 100, discount: 0, billable_amount: 100, net_total: 100, total_paid: 0, due: 100 },
	},
	{
		_id: "inv-partial-002",
		invoice_no: "PLUS-260623-00005",
		invoice_type: "consultation",
		type: "consultation",
		file_no: "PLUS10",
		patient: { full_name: "Asif IQBAL", health_id: "PLUS10" },
		patient_id: "pat-010",
		invoice_date: "2026-06-23T17:00:00",
		payment_status: "partially_paid",
		currency: "INR",
		invoice_amount: 14320,
		paid_amount: 200,
		pending_amount: 14120,
		due_amount: 14120,
		doctor: { full_name: "Shane WATSON" },
		services: buildServices([{ name: "Face To Face Consultation", qty: 1, charges: 14320, amount: 14320 }]),
		payment_history: [{ payment_date: "2026-06-23T17:00:00", paid_amount: 200, payment_mode: "cash" }],
		financial_summary: { sub_total: 14320, discount: 0, billable_amount: 14320, net_total: 14320, total_paid: 200, due: 14120 },
	},
	{
		_id: "inv-partial-003",
		invoice_no: "PLUS-260611-00008",
		invoice_type: "consultation",
		type: "consultation",
		file_no: "PLUS22",
		patient: { full_name: "Owais Hasan RAZA", health_id: "PLUS22", mobile: "2354242342", email: "" },
		patient_id: "pat-022",
		invoice_date: "2026-06-11T15:30:00",
		payment_status: "partially_paid",
		currency: "INR",
		invoice_amount: 200,
		paid_amount: 100,
		pending_amount: 100,
		due_amount: 100,
		invoice: "",
		doctor: { full_name: "Shane WATSON" },
		services: buildServices([{ name: "Face To Face Consultation", qty: 1, charges: 200, amount: 200 }]),
		payment_history: [{ payment_date: "2026-06-11T15:30:00", paid_amount: 100, payment_mode: "cash" }],
		financial_summary: { sub_total: 200, discount: 0, billable_amount: 200, net_total: 200, total_paid: 100, due: 100 },
	},
	{
		_id: "inv-partial-004",
		invoice_no: "PLUS-260623-00006",
		invoice_type: "treatment_package",
		type: "other_services",
		file_no: "PLUS69",
		patient: { full_name: "Sarah BROWN", health_id: "PLUS69" },
		patient_id: "pat-069",
		invoice_date: "2026-06-23T16:00:00",
		payment_status: "unpaid",
		currency: "INR",
		invoice_amount: 100,
		paid_amount: 0,
		pending_amount: 100,
		due_amount: 100,
		doctor: { full_name: "Shane WATSON" },
		services: buildServices([{ name: "Treatment Package", qty: 1, charges: 100, amount: 100 }]),
		payment_history: [],
		financial_summary: { sub_total: 100, discount: 0, billable_amount: 100, net_total: 100, total_paid: 0, due: 100 },
	},
	{
		_id: "inv-partial-005",
		invoice_no: "PLUS-260623-00007",
		invoice_type: "consultation",
		type: "consultation",
		file_no: "PLUS10",
		patient: { full_name: "Asif IQBAL", health_id: "PLUS10" },
		patient_id: "pat-010",
		invoice_date: "2026-06-23T15:00:00",
		payment_status: "unpaid",
		currency: "INR",
		invoice_amount: 100,
		paid_amount: 0,
		pending_amount: 100,
		due_amount: 100,
		doctor: { full_name: "Shane WATSON" },
		services: buildServices([{ name: "Face To Face Consultation", qty: 1, charges: 100, amount: 100 }]),
		payment_history: [],
		financial_summary: { sub_total: 100, discount: 0, billable_amount: 100, net_total: 100, total_paid: 0, due: 100 },
	},
];

export const getAllMockInvoices = () => [...MOCK_PARTIAL_INVOICES, ...MOCK_PAID_INVOICES];

export const getMockInvoiceById = (invoiceId) =>
	getAllMockInvoices().find((inv) => inv._id === invoiceId) || null;
